export const PATHS = {
    HOME: '/',
    ADMIN: '/admin',
    SIGN_IN_CALLBACK: '/signin-callback',
    TENDER_MANUAL: '/manual',
    TENDER_REVIEW: '/tender-review',
    TENDER_REJECTED: '/tender-rejected',
    TENDER_CANCELLED: '/tender-cancelled',
    TENDER_EXPIRED: '/tender-expired',
} as const;